import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { UserSchema } from "../../Schemas/User";

interface Filter extends IFilterSchema {
  column: UsersListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: UsersListColumnSortable;
}

export enum UsersListColumnFilterable {
  ID = "id",
  NAME = "name",
  PHONE = "phone",
}
export enum UsersListColumnSortable {
  ID = "id",
  NAME = "name",
  PHONE = "phone",
  CREATED_AT = "created_at",
}

export interface UsersListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface UsersListResponseBody extends IResponseBody {
  data: {
    users: UserSchema[];
    total: number;
  };
}

export class UsersListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/users`;
  }

  async send(
    queryStrings?: UsersListQueryString
  ): Promise<UsersListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
